import DashboardBarChart from './DashboardBarChart';

export default DashboardBarChart;
